import { ColWidth } from "@/constants/common.constant";
import { TableHeaderConfig } from "@/interfaces/common.interface";

export const VIEW_NAME = "承認コメント補助";
export interface shoninCommentHojoInfo {
  id: number;
  seq: number;
  bunruiNm: string;
  shoninComment: string;
  oldSeq: number; //修正前のSEQ
  hasSeqEdited: boolean; //該当行のSEQは修正されているかフラグ
  hasSeqExisted: boolean; //該当行のSEQは重複されているかフラグ
}

export const tableConfig: TableHeaderConfig[] = [
  {
    prop: "bunruiNm",
    label: "分類",
    width: ColWidth.mini,
  },
  {
    prop: "shoninComment",
    label: "承認コメント",
    class: "text-over", //長すぎると、省略記号で表示
  },
];
